import {
  GreyGrey80,
  Primary13Regular,
  SimpleModal,
  Box
} from '@sequencehq/core-components'
import { type ReactNode } from 'react'

type Props = {
  title: string
  onClose: () => void
  children: ReactNode
  'data-testid': string
}

/**
 * Blocking dialog shown when a send/issue can't proceed and can't be remediated
 * here, e.g. the entity is dated before a lock date the user can't move, or a
 * check couldn't be run. The caller supplies title + message.
 */
export const ConfirmationBlocker = ({
  title,
  onClose,
  children,
  'data-testid': dataTestId
}: Props) => (
  <SimpleModal
    isOpen
    variant="dialog"
    data-testid={dataTestId}
    title={title}
    showFooter
    // A single dismiss button — there's nothing to action here.
    showCancelButton={false}
    submitButtonText="Close"
    // SimpleModal runs its own animated close on a truthy result, which fires
    // onClose — so don't call onClose here too, or it fires twice.
    onSubmit={() => true}
    onClose={onClose}
  >
    <Box {...Primary13Regular} color={GreyGrey80}>
      {children}
    </Box>
  </SimpleModal>
)
